// Shared adminRole-domain i18n keys (used by RoleListing, RoleDetail, RoleAddModal).
// Page-level keys live under `RoleListing.*`, `RoleDetail.*`, `RoleAddModal.*`.

export const adminRoleDict: Record<string, [en: string, th: string]> = {
  // ── Page titles / breadcrumbs ───────────────────────────
  "RoleListing.pageTitle": ["Roles Management", "จัดการบทบาท"],
  "RoleDetail.pageTitle": ["Role Detail", "รายละเอียดบทบาท"],
  "RoleAddModal.pageTitle": ["Create Role", "สร้างบทบาท"],

  // ── RoleListing — page-level keys ───────────────────────
  "RoleListing.search": ["Search Roles", "ค้นหาบทบาท"],
  "RoleListing.column.roleName": ["Role Name", "ชื่อบทบาท"],
  "RoleListing.column.permissions": ["Permissions", "สิทธิ์"],
  "RoleListing.column.createdAt": ["Created At", "วันที่สร้าง"],
  "RoleListing.permissionsAll": ["All", "ทั้งหมด"],

  // ── RoleDetail — page-level keys ────────────────────────
  "RoleDetail.subtitle": ["Permissions and settings for this role", "สิทธิ์และการตั้งค่าของบทบาทนี้"],
  "RoleDetail.card.summary": ["Summary", "สรุป"],
  "RoleDetail.field.roleName": ["Role Name", "ชื่อบทบาท"],
  "RoleDetail.field.permissions": ["Permissions", "สิทธิ์"],
  "RoleDetail.section.permissions": ["Permissions", "สิทธิ์"],
  "RoleDetail.noPermissions": ["No permissions", "ยังไม่มีสิทธิ์ที่กำหนด"],
  "RoleDetail.permissionsOther": ["Other", "สิทธิ์อื่น ๆ"],
  "RoleDetail.button.edit": ["Edit", "แก้ไข"],
  "RoleDetail.button.back": ["Back", "กลับ"],

  // ── RoleAddModal — page-level keys ──────────────────────
  "RoleAddModal.modal.add": ["Add Role", "เพิ่มบทบาท"],
  "RoleAddModal.modal.edit": ["Edit Role", "แก้ไขบทบาท"],
  "RoleAddModal.field.roleName": ["Role Name", "ชื่อบทบาท"],
  "RoleAddModal.field.permissions": ["Permissions", "สิทธิ์"],
  "RoleAddModal.button.save": ["Save", "บันทึก"],
  "RoleAddModal.button.create": ["Create", "สร้าง"],
};
